const getters = {
	getAuthor: state => state.defaults.author,
	getFirstName: state => state.defaults.firstName,
	getLastName: state => state.defaults.lastName,
	getEmail: state => state.defaults.primary_email,
	getAbout: state => state.defaults.about,
	getSecondaryEmail: state => state.defaults.secondary_email,
	getProfileImageUrl: state => state.defaults.profileImageUrl,
	getCVUrl: state => state.defaults.CVUrl,
	getAboutImgUrl: state => state.defaults.about_image_url,
	getJob: state => state.defaults.job,
	getQuote: state => state.defaults.quote,
	getPhoneStyled: state => state.defaults.phone_styled,
	getPhone: state => state.defaults.phone,
	getHome: state => state.defaults.home_address,
	getWork: state => state.defaults.work_address,
	getLocation: state => type => (type == "home" ? state.defaults.home_map : state.defaults.work_map),
	getFacebook: state => state.defaults.facebook_url,
	getTwitter: state => state.defaults.twitter_url,
	getGithub: state => state.defaults.github_url,
	getLinkedIn: state => state.defaults.linkedIn_url,
	getDribble: state => state.defaults.dribble_url,
	getSkills: state => state.skills,
	getTechnicalSkills: state => state.defaults.technical_skills,
	getCategories: state => state.categories,
	getPortfolio: state => state.portfolio,
	getExp: state => state.exp,
};
export default getters;
